import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 tomova', '5 bonusa', '240 strana', '4–15 godina'];
const reassurances = ['Trenutni digitalni pristup', 'PDF za štampu', '7 dana garancije zadovoljstva'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15c2era85gpsf">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbahue7foi1w" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t2yd6q742j8n">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t2ewtdx402wq">
          Vaši treninzi džudoa mogu biti <em className="text-red-700" data-id="element-118" data-mp="223mi8vej199e">spremni već danas.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221jteep41m69">
          Umesto da tražite vežbe, sami pišete svaki trening i nedeljne večeri provodite
          u planiranju, imate uređen paket treninga za celu sezonu. Više vremena za ono
          što je zaista važno:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s6ikb8lan6l0">
          Vaši džudisti. Vaši treninzi. Vaš život van sale.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="124g8xx72f5e5">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="162m8ak5kqip1">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b28on2gp8f22">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1fvkz88ojmlbt"><span className="sr-only" data-id="element-125" data-mp="1ktwcyuhylfzb">Umesto </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1pszei4yqd42j">Jednokratna uplata – bez pretplate.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1ttjc19n7u9p7">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="1tuavxn7gaizn" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3qvqkpyhbh8nh">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3lxf8jh3jum23">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3imuaepzqzct" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}